var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpertImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 96,
    viewBox: "0 0 144 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3493_123316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9719 0.0599365H143.955V67.7321H37.9719V0.0599365Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0018 8.54773H140.924V34.3449H41.0018V8.54773Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.939 12.2739H116.07V13.4833H94.939V12.2739Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.439 16.6854H116.07V17.8948H83.439V16.6854Z",
    fill: "#63A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4765 20.8416H116.07V22.0509H89.4765V20.8416Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.545 24.9821H116.07V26.1914H100.545V24.9821Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.639 29.1227H116.07V30.332H92.639V29.1227Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.114 11.844H125.701V14.4237H123.114V11.844Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.114 16.0002H125.701V18.58H123.114V16.0002Z",
    fill: "#63A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.114 20.1564H125.701V22.7361H123.114V20.1564Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.114 24.3126H125.701V26.8923H123.114V24.3126Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.114 28.4689H125.701V31.0486H123.114V28.4689Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9766 17.72H63.6016V26.319H54.9766V17.72Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0018 37.9279H140.924V63.7251H41.0018V37.9279Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.657 40.2206H121.244V42.8003H118.657V40.2206Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.114 40.2206H125.701V42.8003H123.114V40.2206Z",
    fill: "#63A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.8296 45.8618C82.6183 44.5307 83.7125 43.4052 85.0225 42.5778C86.3324 41.7505 87.8206 41.2449 89.3647 41.1027C90.9088 40.9605 92.4647 41.1857 93.9045 41.7598C95.3443 42.3339 96.6269 43.2405 97.6468 44.4051L98.2773 43.8557C97.1705 42.5914 95.7784 41.6071 94.2156 40.9837C92.6528 40.3604 90.9639 40.1158 89.2878 40.2702C87.6117 40.4245 85.9963 40.9733 84.5744 41.8715C83.1526 42.7697 81.9649 43.9915 81.109 45.4366L81.8296 45.8618Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.434 56.7379L82.1289 56.272C81.0996 54.7415 80.5253 52.9521 80.4722 51.1102C80.419 49.2682 80.8892 47.4489 81.8286 45.8619L81.108 45.4366C80.088 47.1594 79.5774 49.1345 79.6351 51.1342C79.6928 53.1338 80.3164 55.0764 81.434 56.7379Z",
    fill: "#63A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.1889 57.901C99.9198 55.9737 100.884 53.4819 100.9 50.8949C100.916 48.3079 99.983 45.8044 98.2761 43.8558L97.6455 44.4052C99.2179 46.2003 100.078 48.5066 100.063 50.8898C100.048 53.2729 99.1597 55.5685 97.5652 57.344L98.1889 57.901Z",
    fill: "#63A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.266 61.4323C91.7614 61.4312 93.2397 61.1162 94.6049 60.5077C95.97 59.8993 97.1914 59.0111 98.1895 57.901L97.5657 57.3439C96.5701 58.4529 95.3334 59.3205 93.9502 59.8802C92.5669 60.44 91.0737 60.6772 89.5844 60.5738C88.0952 60.4704 86.6493 60.0291 85.3573 59.2835C84.0652 58.5379 82.9611 57.5079 82.1293 56.272L81.4344 56.7378C82.4066 58.1833 83.7209 59.3677 85.2612 60.1864C86.8016 61.0052 88.5205 61.4331 90.266 61.4323Z",
    fill: "#63A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9766 45.8103H63.6016V54.4094H54.9766V45.8103Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.436 51.3997H126.061V59.9987H117.436V51.3997Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0168 0H144V4.48901H38.0168V0Z",
    fill: "#63A5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.654 3.12702C140.193 3.12702 139.819 2.75452 139.819 2.29502C139.819 1.83551 140.193 1.46301 140.654 1.46301C141.115 1.46301 141.488 1.83551 141.488 2.29502C141.488 2.75452 141.115 3.12702 140.654 3.12702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.486 3.12702C137.025 3.12702 136.651 2.75452 136.651 2.29502C136.651 1.83551 137.025 1.46301 137.486 1.46301C137.947 1.46301 138.32 1.83551 138.32 2.29502C138.32 2.75452 137.947 3.12702 137.486 3.12702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.32 3.12702C133.859 3.12702 133.485 2.75452 133.485 2.29502C133.485 1.83551 133.859 1.46301 134.32 1.46301C134.781 1.46301 135.154 1.83551 135.154 2.29502C135.154 2.75452 134.781 3.12702 134.32 3.12702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9058 93.6691H18.7603L17.7394 85.4181L20.9062 85.4182L20.9058 93.6691Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4531 92.9707L17.2277 92.9706H17.2275C16.5134 92.9706 15.8285 93.2535 15.3235 93.7569C14.8185 94.2604 14.5348 94.9432 14.5347 95.6552V95.7424L21.453 95.7427L21.4531 92.9707Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.25 85.5687L24.6667 87.0124L18.3281 81.6106L20.6649 79.48L26.25 85.5687Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1803 84.6851L23.0622 87.5281L23.0621 87.5282C22.5351 88.0088 22.2212 88.6783 22.1894 89.3896C22.1575 90.1009 22.4104 90.7957 22.8924 91.3211L22.9514 91.3855L28.0566 86.7306L26.1803 84.6851Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5331 64.6942L18.1412 76.8198L16.6208 90.0065L21.1817 90.6128L24.0702 73.94L24.9824 62.5721L17.5331 64.6942Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3878 60.2986C10.3878 60.2986 8.56341 72.2727 12.3641 76.2135C16.1648 80.1543 21.3337 87.1266 21.3337 87.1266L24.9824 82.5794L15.7087 72.7274L17.5331 66.0583L24.9824 62.5722L23.7662 54.2358L12.8202 54.0842L10.3878 60.2986Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7591 32.5613C16.7028 32.5613 15.0358 30.8993 15.0358 28.8492C15.0358 26.7991 16.7028 25.1371 18.7591 25.1371C20.8154 25.1371 22.4824 26.7991 22.4824 28.8492C22.4824 30.8993 20.8154 32.5613 18.7591 32.5613Z",
    fill: "#FFB8B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6705 34.125L15.1002 34.9864L13.5798 39.2304L14.796 55.7515L21.9414 55.9032L22.8535 36.9568L20.9427 34.5755L15.6705 34.125Z",
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7439 37.4116L26.9601 37.26C26.9601 37.26 27.2642 37.4116 27.4162 38.4726C27.5682 39.5336 29.3926 48.9309 29.3926 48.9309L26.9601 60.4503L24.2236 56.8126L25.8959 50.4466L24.2236 44.0807L25.7439 37.4116Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2362 37.26H9.32411L7.04365 49.5371L9.17196 59.0861L11.3004 55.5999L10.6923 51.8107L10.9963 48.4762L12.0605 46.5057L10.2362 37.26Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5597 28.8491L17.2367 28.6804C17.2367 28.6804 17.7444 25.8119 18.9291 26.1494C20.1138 26.4868 23.1602 26.8243 23.1602 25.4744C23.1602 24.1246 20.283 22.9435 18.5906 23.1122C16.8982 23.2809 14.7367 23.8407 14.1904 26.3181C13.3145 30.2895 15.9975 31.2926 15.9975 31.2926L15.9529 31.148C15.8289 30.7466 15.82 30.3185 15.9273 29.9122C16.0345 29.506 16.2536 29.1377 16.5597 28.8491Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8066 37.26L21.9418 35.2896L20.8015 34.4559L17.3809 49.5372L15.1005 42.7165L15.7846 34.0012L9.4755 37.26L11.6039 47.5668L11.9079 51.5076L10.9958 54.6906C10.9958 54.6906 7.8032 56.9641 8.86739 59.3893C9.93158 61.8144 11.1478 61.966 11.1478 61.966C11.1478 61.966 16.3167 57.1157 16.6208 55.9031C16.9248 54.6906 17.3809 52.5686 17.3809 52.5686C17.3809 52.5686 19.9654 62.2691 23.0059 62.1175C26.0465 61.9659 26.0465 58.783 26.0465 58.783L25.2864 55.4484L24.0701 51.9623L24.6782 46.2026L26.8066 37.26Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.151039 95.9999H40.5212C40.5612 95.9999 40.5995 95.9841 40.6278 95.956C40.656 95.9278 40.6719 95.8896 40.6719 95.8498C40.6719 95.8099 40.656 95.7717 40.6278 95.7436C40.5995 95.7154 40.5612 95.6996 40.5212 95.6996H0.151039C0.111088 95.6996 0.0727654 95.7154 0.0445175 95.7436C0.0162659 95.7717 0.000404358 95.8099 0.000404358 95.8498C0.000404358 95.8896 0.0162659 95.9278 0.0445175 95.956C0.0727654 95.9841 0.111088 95.9999 0.151039 95.9999Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3493_123316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 96,
    fill: "white",
    transform: "matrix(-1 0 0 1 144 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertImage);
export default __webpack_public_path__ + "static/media/expert_image.571ff16ae421e864644f42cad9ae5dad.svg";
export { ForwardRef as ReactComponent };